module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form form-sp-0"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "75%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "发货通知单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentName) + " " + _vm._s(_vm.Form.AgentAddress) + " " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "edit-form w100",
    attrs: {
      "label": "要求发货时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.RequireSendDate))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "实际发货时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "实际签收时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SignDate))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProjectType == 2),
      expression: "Form.ProjectType==2"
    }]
  }, [_c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "Hi幼教样机数量"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ProtoTypeNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "样机已抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ProtoTypeDeductibleNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "此单需抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderProtoTypeDeductibleNum))])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.PackageName != ''),
      expression: "Form.PackageName!=''"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货情况"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "width": "300px"
    },
    on: {
      "change": _vm.SendStatus
    },
    model: {
      value: (_vm.SendGood),
      callback: function($$v) {
        _vm.SendGood = $$v
      },
      expression: "SendGood"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "全部发货",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "部分发货",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ListGoods != ''),
      expression: "Form.ListGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.Form.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Nums",
      "label": "应发数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实发",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "display": "flex",
            "justify-content": "center"
          },
          attrs: {
            "disabled": _vm.NumShow,
            "min": 0,
            "max": scope.row.Num,
            "size": "small"
          },
          model: {
            value: (scope.row.ActualNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ActualNum", $$v)
            },
            expression: "scope.row.ActualNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftGoods != ''),
      expression: "Form.GiftGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.Form.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Nums",
      "label": "应发数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实发",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "display": "flex",
            "justify-content": "center"
          },
          attrs: {
            "disabled": _vm.NumShow,
            "min": 0,
            "max": scope.row.Num,
            "size": "small"
          },
          model: {
            value: (scope.row.ActualNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ActualNum", $$v)
            },
            expression: "scope.row.ActualNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "电视机机型"
    }
  }, _vm._l((_vm.getDsjTypeList), function(item, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(item.ProName))]), _vm._v(" "), _vm._l((item.info), function(itemc, indexc) {
      return _c('p', [_c('input', {
        attrs: {
          "type": "text",
          "placeholder": itemc.ProName
        }
      })])
    })], 2)
  })), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ApplyPic.length > 0),
      expression: "Form.ApplyPic.length>0"
    }],
    attrs: {
      "label": "租用申请表"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.Form.ApplyPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "订单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "财务审核备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AuditRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AddForm.LogisticsId),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "LogisticsId", $$v)
      },
      expression: "AddForm.LogisticsId"
    }
  }, _vm._l((_vm.Logistics), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": _vm.showDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流单号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "快递或物流单号"
    },
    model: {
      value: (_vm.AddForm.LogisticsCode),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "LogisticsCode", $$v)
      },
      expression: "AddForm.LogisticsCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "包裹件数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "placeholder": "包裹件数"
    },
    model: {
      value: (_vm.AddForm.PackageNum),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "PackageNum", $$v)
      },
      expression: "AddForm.PackageNum"
    }
  }), _vm._v(" 件\n    ")], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.AddForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "Remark", $$v)
      },
      expression: "AddForm.Remark"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.PictureVisible),
      callback: function($$v) {
        _vm.PictureVisible = $$v
      },
      expression: "PictureVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.viewSure
    }
  }, [_vm._v("返回")]), _vm._v("   \n    ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "快递/物流管理",
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.dialogClosed
    },
    model: {
      value: (_vm.visibleShow),
      callback: function($$v) {
        _vm.visibleShow = $$v
      },
      expression: "visibleShow"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.Logistics
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ParmName",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delLogistics(scope.row)
            }
          }
        }, [_vm._v("\n            删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogContent),
      callback: function($$v) {
        _vm.dialogContent = $$v
      },
      expression: "dialogContent"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLogistics
    }
  }, [_vm._v("添 加")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d909bb7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StockOut/AddStockOutHX.vue
// module id = 1570
// module chunks = 1